import React from "react";
const RefreshIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_4251_15215)">
            <path
                d="M19.666 3.33398V8.33398H14.666"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.33398 16.666V11.666H6.33398"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.42565 7.49998C3.84829 6.30564 4.5666 5.23782 5.51354 4.39616C6.46048 3.55451 7.60521 2.96645 8.84089 2.68686C10.0766 2.40727 11.3629 2.44527 12.58 2.79729C13.797 3.14932 14.905 3.80391 15.8007 4.69998L19.6673 8.33331M1.33398 11.6666L5.20065 15.3C6.09627 16.1961 7.2043 16.8506 8.42133 17.2027C9.63836 17.5547 10.9247 17.5927 12.1604 17.3131C13.3961 17.0335 14.5408 16.4455 15.4878 15.6038C16.4347 14.7621 17.153 13.6943 17.5757 12.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_4251_15215">
                <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default RefreshIcon;
